// External imports
import { takeLatest, call, put, CallEffect, PutEffect } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';

// Internal imports
import { loginRequest, loginSuccess, loginFailure } from './authSlice';

// Services (API calls, utilities)
import { AuthService } from '@/api/services/authService';
// import { USER } from '@/utils/constants';

// Define response and payload types
interface LoginResponse {
  firstName: string;
  lastName: string;
  lanId: number;
  username: string;
  email: string;
  apv_groups: string[];
  token: string;
  samAccountName: string;
}

interface LoginPayload {
  // email: string;
  // password: string;
  user?: {
    name?: string;
  };
}

function* loginSaga(
  action: PayloadAction<LoginPayload>,
): Generator<CallEffect<LoginResponse> | PutEffect, void, LoginResponse> {
  try {
    const name = action.payload.user?.name;
    const response: LoginResponse = yield call(AuthService.fetchUserDetail, name as string);
    yield put(
      loginSuccess({
        user: {
          id: '1', // Hardcoded ID for now
          email: response.email,
          apv_groups: response['apv_groups'],
          userClientId: '5001', // Hardcoded client ID
          firstName: response.firstName,
          lastName: response.lastName,
          lanId: response.lanId,
          username: response.username,
          samAccountName: response.samAccountName,
        },
        token: response.token,
      }),
    );

    localStorage.setItem('auth_token', response.token);
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Login failed';

    yield put(loginFailure(errorMessage));
  }
}

export function* watchAuth() {
  yield takeLatest(loginRequest.type, loginSaga);
}
